import React, { useEffect, useState } from "react";
import { Header } from "build-ts/metadata";
import { CustomAgentProto } from "build-ts/custom_agent";
import AgentListComponent from "./AgentListComponent";

interface AgentHeaderListProps {
  agentHeaders: Header[];
  setAgentHeaders?: (headers: Header[]) => void;
  selectedAgent: Header[];
  onAgentSelection?: (header: Header, preloadedAgentData?: CustomAgentProto | null) => Promise<void>;
  onCreateNewAgent?: () => Promise<void>;
  isLoading?: boolean;
}

const ListAgents: React.FC<AgentHeaderListProps> = ({
  agentHeaders,
  setAgentHeaders,
  selectedAgent,
  onAgentSelection,
  onCreateNewAgent,
  isLoading = false,
}) => {
  // Search and filtering logic
  const [filteredHeaders, setFilteredHeaders] = useState<Header[]>([]);
  const [searchTerm, setSearchTerm] = useState("");

  // Filter headers based on search term
  useEffect(() => {
    if (!searchTerm) {
      setFilteredHeaders(agentHeaders);
    } else {
      const filtered = agentHeaders?.filter((header) =>
        header?.name?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredHeaders(filtered);
    }
  }, [agentHeaders, searchTerm]);

  // Handlers for single select mode
  const handleAgentSelection = (header: Header, preloadedAgentData?: CustomAgentProto | null) => {
    if (onAgentSelection) {
      onAgentSelection(header, preloadedAgentData);
    }
  };

  return (
    <AgentListComponent
      filteredHeaders={filteredHeaders}
      selectedAgents={selectedAgent}
      searchTerm={searchTerm}
      onSearchChange={setSearchTerm}
      onAgentSelection={handleAgentSelection}
      onCreateNewAgent={onCreateNewAgent}
      setAgentHeaders={setAgentHeaders}
      isLoading={isLoading}
    />
  );
};

export default ListAgents; 